RivalIQ.apps.Favorites.module('views.selectors', function (selectors, App, Backbone, Marionette, $, _, s) {

    'use strict';

    const AUTO_INTERVAL = 'autoTimeInterval';

    selectors.Interval = RivalIQ.views.Select.mixin({
        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        dashboardModelEvents: {
            'changed:metrics': 'onMetricsChanged'
        },

        onMetricsChanged: function () {
            const me = this;

            me.selected = me.getSelectedInterval();

            const selected = _.find(me.getIntervalOptions(), {
                id: me.selected
            });
            if (selected) {
                me.$el.find('.dropdown-active').html(selected.name);
            }
        },

        onChange: function (interval) {
            const me = this;

            const newProps = {};
            if (interval === AUTO_INTERVAL) {
                newProps.useAutoTimeInterval = true;
                newProps.interval = undefined;
            } else {
                newProps.useAutoTimeInterval = undefined;
                if (_.result(me.dashboardModel.getWidget(), 'intervalAppliesToAllMetrics', true)) {
                    let metric = me.dashboardModel.baseMetric;
                    metric = RivalIQ.metric.timePeriod.setInterval(metric, interval);
                    me.dashboardModel.setBaseMetric(metric);
                } else {
                    newProps.interval = interval;
                }
            }

            me.dashboardModel.getWidget().setProps(newProps, {
                navigate: false
            });
        },

        getIntervalOptions: function () {
            const me = this;

            let intervals = _.map(RivalIQ.props.supportedIntervals(me.dashboardModel.getProps()), function (value) {
                return {
                    id: value,
                    name: s.capitalize(value)
                };
            });

            intervals = [{
                id: AUTO_INTERVAL,
                name: 'Auto'
            }].concat(intervals);

            return intervals;
        },

        isDisabled: function () {
            const me = this;
            return !_.result(me.dashboardModel.getWidget(), 'supportsInterval', true);
        },

        initialize: function (options) {
            const me = this;

            _.extend(me, options);

            me.items = me.getIntervalOptions();
            me.selected = me.getSelectedInterval();
        },

        resetSelector: function () {
            const me = this;
            me.items = me.getIntervalOptions();
            me.selected = me.getSelectedInterval();
            me.setItems(me.items, me.selected);
        },

        getSelectedInterval: function () {
            const me = this;

            let selected;
            if (me.dashboardModel.getWidget().getProp('useAutoTimeInterval')) {
                selected = AUTO_INTERVAL;
            } else {
                if (_.result(me.dashboardModel.getWidget(), 'intervalAppliesToAllMetrics', true)) {
                    selected = RivalIQ.metric.timePeriod.getInterval(me.dashboardModel.baseMetric) || AUTO_INTERVAL;
                } else {
                    selected = me.dashboardModel.getWidget().getProp('interval') || AUTO_INTERVAL;
                }
            }
            return selected;
        }
    });

}, window.s);
